import React, { useState } from 'react';
import './SandboxHeader.scss';
import { Routes } from '../../app/AppRouter';
import { setSandbox } from '../../features/sandbox/sandboxSlice';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

export const SandboxHeader: React.FC = () => {
  const [displayHeader, setDisplayHeader] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  function dismissHeader() {
    setDisplayHeader(false);
  }

  function changeToLiveVersion() {
    dispatch(setSandbox(false));

    history.push(Routes.home);
  }

  return (
    <>
      {displayHeader && (
        <div className={'sandbox-header'}>
          <div className={'sandbox-header-container'}>
            <div className={'sandbox-header-icon'}>
              <span role={'img'} aria-label={'HAT testing warning icon'}>
                ⚠️
              </span>
            </div>

            <div className={'sandbox-header-content'}>
              <div className={'sandbox-header-text-container'}>
                <div className={'sandbox-header-text-title'}>
                  You are about to create or log in with a{' '}
                  <span className={'hatters-test sandbox-test-word'}>Test</span> HAT.
                </div>
                <div className={'sandbox-header-text-subtitle'}>
                  These HATs are used for testing purposes and may not be fully functional. Data loss may occur for test
                  HATs so please be aware.
                </div>
              </div>

              <div className={'sandbox-header-button-container'}>
                <button className={'sandbox-header-btn sandbox-header-btn-blue'} onClick={() => dismissHeader()}>
                  OK
                </button>

                <button
                  className={'sandbox-header-btn sandbox-header-btn-transparent'}
                  onClick={() => changeToLiveVersion()}
                >
                  Go to live version
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
